import React, { useState, useRef, useEffect } from 'react';
import {
  Box,
  Button,
  Container,
  Heading,
  Text,
  VStack,
  HStack,
  Input,
  Spinner,
  IconButton,
} from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useVerifyOtpLogin, useResendOtpLogin, useVerifyOtpSignUp } from '../utils/auth.api';

export default function VerifyOtpSignUpPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { mutate: verifyOtp, isLoading } = useVerifyOtpSignUp();
  const { mutate: resendOtp, isLoading: isResending } = useResendOtpLogin(); 
  // const [otp, setOtp] = useState(['', '', '', '']);
  // const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [otp, setOtp] = useState(Array(6).fill(''));


  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [timer, setTimer] = useState(60); // 60 seconds countdown
  const passedUserName = location.state?.email || '';
  
  // Refs for OTP inputs
  const inputRefs = useRef([]);

  // Timer effect
  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer(prev => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  // Format timer display
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  // Handle OTP input change
  // const handleOtpChange = (index, value) => {
  //   // Only allow numbers
  //   if (!/^\d*$/.test(value)) return;
    
  //   const newOtp = [...otp];
  //   newOtp[index] = value;
  //   setOtp(newOtp);

  //   // Auto-focus next input
  //   // if (value && index < 3) {
  //   //   inputRefs.current[index + 1]?.focus();
  //   // }
  //   if (value && index < otp.length - 1) {
  //     inputRefs.current[index + 1]?.focus();
  //   }
    
  // };

  const handleOtpChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;
  
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
  
    if (value && index < otp.length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };
  

  // Handle backspace
  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  // Resend OTP
  const handleResend = async () => {
    try {
      console.log("passedUserName..", passedUserName);
      console.log("Timer value:", timer);
      console.log("isResending:", isResending);
      await resendOtp(passedUserName);
      setTimer(60);
      setOtp(Array(6).fill(''));
              toast.success('OTP resent successfully');
    } catch (err) {
      console.error('Error resending OTP:', err);
      toast.error(`Failed to resend OTP: ${err?.message}`);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const otpCode = otp.join('');
    
    // if (!otpCode || otpCode.length !== 4) {
    //   toast.warning('Please enter complete OTP');
    //   return;
    // }

    if (!otpCode || otpCode.length !== 6) {
      toast.warning('Please enter complete 6-digit OTP');
      return;
    }
    


    try {
      await verifyOtp({ 
        email: passedUserName, 
        otp: otpCode,
       
      });
      
      toast.success('OTP Verified Successfully');
      navigate('/dashboard');

    } catch (err) {
      console.error('Error:', err);
      toast.error(`Failed to verify: ${err?.message}`);
    }
  };

  return (
    <Box minH="100vh" bg="white">
      <Container maxW={{ base: "full", sm: "sm" }} centerContent px={{ base: 4, sm: 6 }}>
        <VStack spacing={{ base: 6, sm: 8 }} w="100%" pt={{ base: 6, sm: 8 }}>
          {/* Header with back button */}
          <HStack w="100%" justify="space-between" align="center">
            <IconButton
              icon={<ArrowBackIcon />}
              variant="ghost"
              onClick={() => navigate(-1)}
              aria-label="Go back"
            />
            <Text fontWeight="semibold" fontSize="lg">OTP</Text>
            <Box w="40px" /> {/* Spacer for centering */}
          </HStack>

          {/* Title Section */}
          <Box textAlign="center" w="100%" px={{ base: 2, sm: 0 }}>
            <Heading as="h1" size={{ base: "md", sm: "lg" }} color="gray.900" fontWeight="bold" mb={3}>
              Email verification
            </Heading>
            <Text color="gray.500" fontSize={{ base: "xs", sm: "sm" }} textAlign="center" mb={1}>
              Enter the verification code we send you on:
            </Text>
            <Text color="gray.500" fontSize={{ base: "xs", sm: "sm" }} fontWeight="medium" wordBreak="break-all">
              {passedUserName}
            </Text>
          </Box>

          {/* OTP Input Section */}
          <VStack spacing={{ base: 4, sm: 6 }} w="100%">
            {/* <HStack spacing={4} justify="center">
              {otp.map((digit, index) => (
                <Input
                  key={index}
                  ref={el => inputRefs.current[index] = el}
                  value={digit}
                  onChange={(e) => handleOtpChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  maxLength={1}
                  textAlign="center"
                  fontSize="2xl"
                  fontWeight="bold"
                  w="60px"
                  h="60px"
                  bg="gray.50"
                  borderColor="gray.200"
                  borderRadius="lg"
                  _focus={{ borderColor: "#5A5BED", boxShadow: "0 0 0 1px #5A5BED" }}
                  inputMode="numeric" // Shows number keyboard on mobile
                  pattern="[0-9]*" // Additional hint for numeric input
                />
              ))}
            </HStack> */}


<HStack 
  spacing={{ base: 2, sm: 3, md: 4 }} 
  justify="center" 
  w="100%"
  px={{ base: 4, sm: 2 }}
>
  {otp.map((digit, index) => (
    <Input
      key={index}
      ref={el => inputRefs.current[index] = el}
      value={digit}
      onChange={(e) => handleOtpChange(index, e.target.value)}
      onKeyDown={(e) => handleKeyDown(index, e)}
      maxLength={1}
      textAlign="center"
      fontSize={{ base: "xl", sm: "2xl" }}
      fontWeight="bold"
      w={{ base: "45px", sm: "50px", md: "60px" }}
      h={{ base: "50px", sm: "55px", md: "60px" }}
      minW={{ base: "45px", sm: "50px", md: "60px" }}
      minH={{ base: "50px", sm: "55px", md: "60px" }}
      bg="gray.50"
      borderColor="gray.200"
      borderRadius="lg"
      _focus={{ borderColor: "#5A5BED", boxShadow: "0 0 0 1px #5A5BED" }}
      _hover={{ borderColor: "gray.300" }}
      inputMode="numeric"
      pattern="[0-9]*"
      flex="1"
      maxW={{ base: "50px", sm: "55px", md: "60px" }}
    />
  ))}
</HStack>

            {/* Resend Section */}
            <VStack spacing={2} px={{ base: 4, sm: 0 }}>
              <Text fontSize={{ base: "xs", sm: "sm" }} color="gray.500" textAlign="center">
                Didn't receive code?{' '}
                {timer > 0 ? (
                  <Text as="span" color="gray.400">
                    Resend in {formatTime(timer)}
                  </Text>
                ) : (
                  <Text 
                    as="span" 
                    color="#5A5BED" 
                    cursor={isResending ? "not-allowed" : "pointer"}
                    fontWeight="medium"
                    onClick={isResending ? undefined : () => {
                      console.log("Resend button clicked!");
                      handleResend();
                    }}
                    opacity={isResending ? 0.6 : 1}
                  >
                    {isResending ? "Resending..." : "Resend"}
                  </Text>
                )}
              </Text>
              
              {/* {timer > 0 && (
                <Text fontSize="sm" color="gray.400">
                  ⏱ {formatTime(timer)}
                </Text>
              )} */}
            </VStack>
          </VStack>

          {/* Password Fields (if needed for your flow) */}
          {/* <VStack spacing={4} w="100%" display="none">
            <Input
              type="password"
              placeholder="Enter New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              size="lg"
              bg="gray.50"
              borderColor="gray.200"
              borderRadius="lg"
            />
            <Input
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              size="lg"
              bg="gray.50"
              borderColor="gray.200"
              borderRadius="lg"
            />
          </VStack> */}

          {/* Continue Button */}
          <Button
            w="100%"
            bg="#5A5BED"
            height={{ base: "48px", sm: "50px" }}
            color="white"
            fontWeight="semibold"
            borderRadius="100px"
            fontSize={{ base: "sm", sm: "md" }}
            isLoading={isLoading}
            loadingText="Verifying..."
            spinner={<Spinner size="sm" color="white" />}
            _hover={{ bg: "#4A4BDD" }}
            onClick={handleSubmit}
            mt={{ base: 6, sm: 8, md: 4 }}
            isDisabled={otp.join('').length !== 6}
            px={{ base: 4, sm: 6 }}
          >
            Continue
          </Button>
        </VStack>
      </Container>
    </Box>
  );
}